/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class FieldService extends services.DataService<Wars.Domain.Model.Field> {
        public getField(id: string): angular.IPromise<Wars.Domain.Model.Field> {
            return this.fetchById(id, "Field");
        }

        public createFieldExcludedStatuses():Wars.Domain.Model.FieldExcludedStatuses {
            return <Wars.Domain.Model.FieldExcludedStatuses>this.createNewEntity("FieldExcludedStatuses");
        }

        public createFieldExcludedSystemCodes():Wars.Domain.Model.FieldExcludedSystemCodes {
            return <Wars.Domain.Model.FieldExcludedSystemCodes>this.createNewEntity("FieldExcludedSystemCodes");
        }

        public createFieldExcludedProcessTypes(): Wars.Domain.Model.FieldExcludedProcessTypes {
            return <Wars.Domain.Model.FieldExcludedProcessTypes>this.createNewEntity("FieldExcludedProcessTypes");
        }

        public createFieldExcludedStates():Wars.Domain.Model.FieldExcludedStates {
            return <Wars.Domain.Model.FieldExcludedStates>this.createNewEntity("FieldExcludedStates");
        }
    }
}

warsApp.registerService('FieldService', ['breeze', '$q', '$http'])